import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { useNavigate } from "react-router-dom";

const banners = [
  { src: "/assets/swiper/solitaire-games.png", alt: "Solitaire card game" },
  { src: "/assets/swiper/mind-mining-games.png", alt: "Mind mining puzzle game" },
  { src: "/assets/swiper/cricket.png", alt: "Cricket game" },
  { src: "/assets/swiper/supercar-racing.png", alt: "Supercar racing game" },
  { src: "/assets/swiper/battle-arena-new.png", alt: "Battle arena game" },
  { src: "/assets/swiper/city-inferno.png", alt: "City inferno pursuit game" },
  { src: "/assets/swiper/sky-race-new.png", alt: "Sky race game" },
  { src: "/assets/swiper/road-mash-new.png", alt: "Road mash off-road game" },
];
function Slider() {
  const navigate = useNavigate();

  return (
    <div className="relative w-full overflow-hidden bg-black">
      
      {/* ================= SLIDER ================= */}
      <Swiper
        modules={[Autoplay]}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        loop
        speed={900}
        slidesPerView={1}
        spaceBetween={0}
        className="w-full h-[380px] sm:h-[420px] md:h-[460px]"
      >
        {banners.map((banner) => (
          <SwiperSlide key={banner.src}>
            <div className="w-full h-full overflow-hidden bg-black">
              <img
                src={banner.src}
                alt={banner.alt}
                className="block w-full h-full object-cover"
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* ================= LEFT TEXT (SAME POSITION) ================= */}
      <div className="absolute inset-0 z-10 flex items-center">
        <div className="max-w-7xl mx-auto w-full px-6 sm:px-10">
          <div className="max-w-xl text-left text-white">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-3">
              Level Up Your Game
            </h1>
            <p className="text-base sm:text-lg mb-6 text-gray-200">
              Play Without Limits
            </p>
            <button
              onClick={() => navigate("/games")}
              className="bg-yellow-500 hover:bg-yellow-400 text-black px-6 py-3 rounded-lg font-semibold transition-all"
            >
              Let&apos;s Play
            </button>
          </div>
        </div>
      </div>

      {/* ================= HARD FIX (LINE ISSUE) ================= */}
      <style>{`
        .swiper {
          overflow: hidden;
        }
        .swiper-slide {
          backface-visibility: hidden;
          -webkit-backface-visibility: hidden;
          transform: translateZ(0);
        }
        img {
          display: block;
        }
      `}</style>
    </div>
  );
}

export default Slider;



